import { FC, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { EmptyState, GroupedList, MerchantsListItem } from "../../lib";
import { listMerchantsApi } from "../../utils/api/merchants-apis";
import { createFilterObject, MerchantsFilters } from "../filters";

type Props = {
  refresh: boolean;
  setRefresh: (refresh: boolean) => any;
  setIsLoading: (state: boolean) => void;
  activeTab?: string;
  limit?: number;
};

const ListMerchants: FC<Props> = ({
  setIsLoading,
  refresh,
  setRefresh,
  activeTab,
  limit = 10,
}: Props) => {
  const [merchants, setMerchants] = useState<any>([]);
  const [pages, setPages] = useState(1);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchMerchants = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await listMerchantsApi({
        page,
        filter: createFilterObject(
          activeTab ? activeTab : "",
          MerchantsFilters
        ),
        limit,
      });
      setPages(response.pages);
      setMerchants(response.merchants);
      setIsLoading(false);
    } catch (e) {
      console.log({ e });
      setIsLoading(false);
    }
  };

  const goToMerchant = (merchant: any) => navigate("./" + merchant.id);

  useEffect(() => {
    fetchMerchants();
  }, [refresh, activeTab]);

  return merchants.length ? (
    <GroupedList
      pages={{
        total: pages,
        selectPage: (page: number) => fetchMerchants(page),
      }}
      role={"client"}
      data={merchants}
      component={MerchantsListItem}
      onItemClick={(item) => goToMerchant(item)}
      groupBy={{
        key: "created_at",
        isDate: true,
      }}
    />
  ) : (
    <EmptyState title={t("itemNotFound")} />
  );
};

export default ListMerchants;
